module.exports = __webpack_public_path__ + "static/energy_pkg_2-83a09bdc374c3b4663985c9aa91a0eb3.png";